"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_router_dom_1 = require("react-router-dom");
const react_1 = __importStar(require("react"));
const MainLayout_1 = __importDefault(require("./MainLayout"));
const services_1 = require("../../../common/services");
const withStore_1 = __importDefault(require("../../../common/decorators/withStore"));
function DsStream(props) {
    const { slug, streamSlug } = (0, react_router_dom_1.useParams)();
    const [streamData, setStreamData] = (0, react_1.useState)({});
    (0, react_1.useEffect)(() => {
        services_1.apiService
            .getDsStream('en', slug, streamSlug)
            .then((data) => setStreamData(data))
            .catch(error => {
            console.error('Stream data error:', error);
            setTimeout(() => {
                window.location.reload();
            }, 5000);
        });
    }, []);
    (0, react_1.useEffect)(() => {
        if (props.reloadNeeded) {
            services_1.apiService
                .getDsStream('en', slug, streamSlug)
                .then((data) => {
                setStreamData(data);
                props.updateStore('reloadNeeded', false);
            })
                .catch(error => {
                console.error('Stream data error:', error);
                props.updateStore('reloadNeeded', false);
            });
        }
    }, [props.reloadNeeded]);
    if (Object.keys(streamData).length === 0) {
        return null;
    }
    return react_1.default.createElement(MainLayout_1.default, { isDsStream: true, streamData: streamData });
}
const mapStoreToProps = store => ({
    reloadNeeded: store.getValue('reloadNeeded'),
});
exports.default = (0, withStore_1.default)(mapStoreToProps)(DsStream);
